import { Rnd } from 'react-rnd';
import React, { useState } from "react";


export default function FolderItemForReordering(props) {
    const { order, maxWidth, startingHeight, height,
        onRearrange, createLocator, endLocator, overallStartingHeights,
        opacity, setOpacity, item, type } = props;

    const [transitionEnabled, setTransitionEnabled] = useState(true);

    const handleDragStart = () => {
      setTransitionEnabled(false);
    }

    const handleDrag = (e, data) => {
      const checkingStartingHeights = [...overallStartingHeights];
      if (type !== "folders" || (!item.collectionId && !item.folderId)) {
        checkingStartingHeights.shift()
      }
      if (data.y <= startingHeight) {
        const closestHeight = checkingStartingHeights.reduce((a, b) => {
          return Math.abs(b - data.y) < Math.abs(a - data.y) ? b : a;
        });
        createLocator(closestHeight - 5, data.x + 21, maxWidth)
      } if (data.y > startingHeight) {
        const closestHeight = checkingStartingHeights.reduce((a, b) => {
          return Math.abs(b - (data.y + height)) < Math.abs(a - (data.y + height)) ? b : a;
        });
        createLocator(closestHeight -5, data.x + 21, maxWidth)
      }
    }

    const handleDragStop = (e, data) => {
      const checkingStartingHeights = [...overallStartingHeights];
      if (type !== "folders" || (!item.collectionId && !item.folderId)) {
        checkingStartingHeights.shift()
      }
      endLocator();
      if (data.y <= startingHeight) {
        var closestHeight = checkingStartingHeights.reduce((a, b) => {
          return Math.abs(b - data.y) < Math.abs(a - data.y) ? b : a;
        });
      } if (data.y > startingHeight) {
        closestHeight = checkingStartingHeights.reduce((a, b) => {
          return Math.abs(b - (data.y + height)) < Math.abs(a - (data.y + height)) ? b : a;
        });
      }
      var desiredOrder = checkingStartingHeights.findIndex((blockItem) => ((blockItem === closestHeight))) + 1;
      if (type === "folders" && (item.collectionId || item.folderId)) {
        desiredOrder --;
      }
      if (desiredOrder > order) {
        desiredOrder --;
      }
      if (desiredOrder !== order) {
        setOpacity(0);
        onRearrange(item.id, item.type , order, desiredOrder);  
        setTimeout(() => {
          setOpacity(1)
          setTransitionEnabled(true)
        }, 150)
      }
    }
    return(
    <div>
        <Rnd
        disableDragging={(type === "pages" && item.isProfile === 1)}
        className="block"
        bounds="#reorderer"
        dragGrid={[100, 20]}
        position={{ x: -14, y: startingHeight }}
        size={{ width: maxWidth, height }}
        minWidth={maxWidth}
        maxWidth={maxWidth}
        minHeight={40}
        onDragStart={handleDragStart}
        onDrag={handleDrag}
        onDragStop={handleDragStop}
        style={{
          transition: transitionEnabled ? "all 0.1s ease-in-out" : "none",
          opacity: opacity
        }}
        enableResizing={{
          top: false,
          right: false,
          bottom: false,
          left: false,
          topRight: false,
          bottomRight: false,
          bottomLeft: false,
          topLeft: false,
        }}
      >
        <div className="block-inner reordering-block">
          <div className="border-block"></div>
          <div className="block-title-container">
            <div className="block-title reordering-block-title">
              <div className="block-title-border-block" style={{top: `20px`}}></div>
              <h5>{item.title}</h5>
            </div>
          </div>
          <div id="stuff" className="reordering-block-content">
            {item.type !== "skinFolder" ? <p>{item.type}</p>
              : <p>skin folder</p>
            }
          </div>
        </div>
      </Rnd>
    </div>)
}